export default "__VITE_ASSET__M6pSOTQsTbzFZtJEdPfJ0Q__"